<template>
  <div class="memeber-wrapper">
    <!--会员中心首页左侧-->
    <div class="menu-wrapper">
      <div class="round header"></div>
      <h1>
        <router-link to="/member/member">会员中心首页</router-link>
      </h1>
      <!--会员中心左侧会员缩略图-->
      <div class="breviary">
        <img
          v-if="$store.getters.face && $store.getters.face.length > 0"
          :src="$store.getters.face"
          alt="会员头像缩略图"
        />
        <img
          v-else
          src="//static.kxymall.com/images/hutx.jpg"
          alt="会员头像缩略图"
        />
        <div class="member-info">
          <h2>{{ $store.getters.name }}</h2>
          <p>会员等级：{{ this.memberName }}</p>
        </div>
      </div>
      <!--会员中心左侧列表-->
      <div class="inner_wrapper">
        <div class="menu-part manage">
          <h2>交易管理</h2>
          <ul>
            <li>
              <router-link to="/member/order?status=-1">我的订单</router-link>
            </li>
            <li>
              <router-link to="/member/returnList">退换货</router-link>
            </li>
            <li>
              <router-link to="/member/address">收货地址</router-link>
            </li>
          </ul>
        </div>
        <div class="menu-part lens">
          <h2>收藏夹</h2>
          <ul>
            <li>
              <router-link
                :to="{ path: '/member/favorite', query: { status: 1 } }"
                >我的收藏</router-link
              >
            </li>
          </ul>
        </div>
        <div class="menu-part accounts">
          <h2>评论管理</h2>
          <ul>
            <li>
              <router-link to="/member/comments">我的评论</router-link>
            </li>
            <li>
              <router-link to="/member/myAdvice">我的咨询</router-link>
            </li>
          </ul>
        </div>
        <div class="menu-part password">
          <h2>帐号管理</h2>
          <ul>
            <li>
              <router-link to="/member/personalProfile"
                >完善基本资料</router-link
              >
            </li>
            <!-- <li>
              <router-link to="/member/myshoppingScore"
                >购物积分获取记录</router-link
              >
            </li> -->
            <!-- <li>
              <router-link to="/member/myGrowth">我的成长值</router-link>
            </li> -->
            <li>
              <router-link to="/member/shoppingScore">我的积分</router-link>
            </li>
            <!--<li><router-link to="/member/myRecommend">我推荐的免费会员</router-link></li>-->
            <li>
              <router-link to="/member/security">修改登录密码</router-link>
            </li>
            <li>
              <router-link to="/member/payPassWord">修改支付密码</router-link>
            </li>
            <li><router-link to="/member/bankCard">我的银行卡</router-link></li>
            <!--<li><router-link to="/member/myCoupons">我的优惠券</router-link></li>-->
          </ul>
        </div>
        <div class="menu-part applyCenter">
          <h2>申请中心</h2>
          <ul>
            <li><a @click="openShop">免费开店</a></li>
            <li><a @click="applyBusiness">申请联盟商家</a></li>
            <li v-if="applyStatus == 2"><a @click="goodsImage">商品图</a></li>
            <li><a @click="openShop">申请服务站</a></li>
            <!-- <li><a
                @click="openRecharge"
                v-text="firstBuyShow == 0 ? '充值优品服务站' : '服务站充值'"
              ></a></li>
            <li><a
                @click="openCloud"
                v-if="isShowOpenCloud"
              >支付开网店</a></li> -->
          </ul>
        </div>
      </div>
      <div class="round bottom"></div>
    </div>
    <!--会员中心首页右侧-->
    <div class="content_wrapper">
      <div class="content-box header"></div>
      <router-view></router-view>
      <div class="content-box bottom"></div>
    </div>
    <!--会员中心首页右侧结束-->
  </div>
</template>
<style lang="less">
@import "../../assets/css/user.less";
</style>
<script>
import { mapGetters } from "vuex";
import { getSession } from "utils/tool";
import { isApplyLeague } from "api/user";
import {
  sellerDevelopURL,
  sellerProductURL,
  sellerPrepareURL,
  H5_DEV_URL,
  H5_PRE_URL,
  H5_PRO_URL,
} from "utils/url";
export default {
  data() {
    return {
      sellerUrl: "",
      h5Url: "",
      isShowOpenCloud: false,
      memberName: "",
      applyStatus: null
    };
  },

  computed: {
    ...mapGetters(["sid", "name", "isFirstBuy"]),
    isLogin() {
      return this.sid && this.sid.length > 0 ? true : false;
    },
    firstBuyShow: {
      get() {
        return eval(this.isFirstBuy) && this.isLogin;
      },
    },
  },
  created() {
    this.isApplyLeague();
    this.memberName = getSession("membershipLevelName");
    if (getSession("membershipLevelName") == "免费会员") {
      this.isShowOpenCloud = true;
    } else {
      this.isShowOpenCloud = false;
    }
    if (location.hostname === "www.kxymall.com") {
      this.sellerUrl = sellerProductURL;
      this.h5Url = H5_PRO_URL;
    } else if (location.hostname === "prepare.kxymall.com") {
      this.sellerUrl = sellerPrepareURL;
      this.h5Url = H5_PRE_URL;
    } else {
      this.sellerUrl = sellerDevelopURL;
      this.h5Url = H5_DEV_URL;
    }
  },

  mounted() {},

  methods: {
    isApplyLeague() {
      isApplyLeague({}).then((res) => {
        if (res.resCode == 1) {
          if (res.data) {
            // this.sn = res.data.sn;
            this.applyStatus = res.data.status;
            // this.notPassReason = res.data.notPassReason;
            // if (this.applyStatus == 2) {
            //   this.$router.push({
            //     path: "/myData/businessLeague",
            //     query: { status: this.status, page: "businessLeague" },
            //   });
            // }
          } else {
            this.applyStatus = null;
          }
        }
      });
    },
    // 服务站充值
    openRecharge() {
      let sid = getSession("sid");
      let loginName = getSession("userName");
      let targetUrl =
        this.h5Url +
        `applyPointsCloud/index?sid=${sid}&loginName=${loginName}&page=PC`;
      window.open(targetUrl);
    },
    // 云优品服务站
    openCloud() {
      let sid = getSession("sid");
      let loginName = getSession("userName");
      let targetUrl =
        this.h5Url +
        `payOnlineStore/index?sid=${sid}&loginName=${loginName}&page=PC`;
      window.open(targetUrl);
    },
    // 跳转到免费开店和申请云优品店
    openShop() {
      let sid = getSession("sid");
      let token = getSession("token");
      let targetUrl =
        this.sellerUrl +
        "/templates/index.html?loginSource=buyer&sid=" +
        sid +
        "&token=" +
        token;
      window.open(targetUrl);
    },
    // 申请联盟商家
    applyBusiness() {
      this.$router.push({
        path: "/createLeague",
        query: { status: 1 },
      });
    },
    // 联盟商家商品图
    goodsImage() {
      this.$router.push({
        path: "/createLeague",
        query: { status: 2 },
      });
    },
    // 申请实体店
    applyForPhysicalStore() {
      let sid = getSession("sid");
      let token = getSession("token");
      let targetUrl =
        this.sellerUrl +
        "/templates/reportCenter/apply.html?loginSource=buyer&sid=" +
        sid +
        "&token=" +
        token;
      window.open(targetUrl);
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?6c7d459d